import _ from 'lodash';
import { TeamMember, User } from '../store/types';

export const getPropertyAsValidDate = <T>(
    a: T,
    propertyPath: string
): Date | null => {
    const property = _.get(a, propertyPath);
    if (
        !(
            typeof property === 'string' ||
            typeof property === 'number' ||
            property instanceof Date
        )
    ) {
        return null;
    }

    return new Date(property as Date | number | string);
};

export const getPropertyAsValidString = <T>(
    a: T,
    propertyPath: string
): string => {
    const property = _.get(a, propertyPath, '');
    if (typeof property === 'string') {
        return property as string;
    }
    // eslint-disable-next-line no-prototype-builtins
    if ((property as any).hasOwnProperty('toString')) {
        return (property as any).toString();
    }
    return '';
};

export const getPropertyAsValidNumber = <T>(
    a: T,
    propertyPath: string
): number => {
    const property = _.get(a, propertyPath, '0');

    if (typeof property === 'number') {
        return property as number;
    }
    if (typeof property === 'string') {
        return parseInt(property as string);
    }
    return 0;
};

export const getPropertyAsValidBoolean = <T>(
    a: T,
    propertyPath: string
): boolean => {
    const property = _.get(a, propertyPath, false);
    if (!(typeof property === 'boolean')) {
        return false;
    }
    return property as boolean;
};

export const getPropertyAsUser = <T>(
    a: T,
    propertyPath: string
): User | null => {
    const essentialFields = ['firstName', 'lastName'];
    const property = _.get(a, propertyPath);

    if (
        property &&
        essentialFields.every((essentialField) =>
            Object.prototype.hasOwnProperty.call(property, essentialField)
        )
    ) {
        return property as unknown as User;
    }
    return null;
};

const getTeamMemberFromProperty = (property: any): TeamMember | null => {
    const essentialFieldMember = 'member';
    const essentialFields = [essentialFieldMember, 'teamMemberTasks'];
    const user = getPropertyAsUser(property, essentialFieldMember);

    if (!user) {
        return null;
    }

    if (
        property &&
        essentialFields.every((essentialField) =>
            Object.prototype.hasOwnProperty.call(property, essentialField)
        )
    ) {
        return property as unknown as TeamMember;
    }
    return null;
};

export const getPropertyAsTeamMembers = <T>(
    a: T,
    propertyPath: string
): Array<TeamMember> => {
    const teamMembers: Array<TeamMember> = [];
    const property = _.get(a, propertyPath);

    if (!_.isArray(property)) {
        return teamMembers;
    }
    for (const teamMemberCandidate of property) {
        const teamMember = getTeamMemberFromProperty(teamMemberCandidate);
        if (teamMember) {
            teamMembers.push(teamMember);
        }
    }

    return teamMembers;
};
